angular.module('user')
    .component('userSearch', {
        bindings: {
            autofocus: '<?',
            limit: '<?',
            minLength: '<?',
            onCancel: '&?',
            onSelect: '&'
        },
        templateUrl: 'app/user/user-search.html',
        controller: function ($element, $timeout, User, UserService) {
            let requestSequence = 0

            this.$onInit = () => {
                this.limit = this.limit || 10
                this.minLength = angular.isDefined(this.minLength) ? this.minLength : 0
                this.query = ''
                this.results = []
                this.visibleUsers = []
                this.activeIndex = -1
                this.loading = false
                this.loadError = false
            }

            this.$postLink = () => {
                if (this.autofocus === false) {
                    return
                }

                $timeout(() => {
                    const input = $element[0].querySelector('.user-search__input')
                    if (input) {
                        input.focus()
                    }
                    this.search()
                })
            }

            this.search = () => {
                const query = normalizedQuery()
                const requestId = ++requestSequence
                this.loadError = false
                this.results = []
                this.visibleUsers = []
                this.activeIndex = -1

                if (query.length < this.minLength) {
                    this.loading = false
                    return
                }

                this.loading = true
                return User.autocomplete({q: query}).$promise
                    .then(items => {
                        if (requestId !== requestSequence) {
                            return
                        }

                        this.results = sortUsers(items)
                        this.visibleUsers = this.results.slice(0, this.limit)
                        this.activeIndex = this.visibleUsers.length ? 0 : -1
                    })
                    .catch(() => {
                        if (requestId !== requestSequence) {
                            return
                        }

                        this.loadError = true
                    })
                    .finally(() => {
                        if (requestId === requestSequence) {
                            this.loading = false
                        }
                    })
            }

            this.select = user => {
                if (!user || !user.id) {
                    return
                }

                this.onSelect({$user: user})
            }

            this.openProfile = (user, event) => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                this.select(user)
            }

            this.edit = (user, event) => {
                if (event) {
                    event.preventDefault()
                    event.stopPropagation()
                }
                if (!user || !user.id) {
                    return
                }
                if (angular.isFunction(this.onCancel)) {
                    this.onCancel()
                }
                UserService.editModal(user.id)
            }

            this.stopEvent = event => {
                if (event) {
                    event.stopPropagation()
                }
            }

            this.onKeydown = event => {
                if (event.key === 'ArrowDown') {
                    event.preventDefault()
                    moveActive(1)
                    return
                }

                if (event.key === 'ArrowUp') {
                    event.preventDefault()
                    moveActive(-1)
                    return
                }

                if (event.key === 'Enter') {
                    const user = this.visibleUsers[this.activeIndex] || (this.visibleUsers.length === 1 ? this.visibleUsers[0] : null)
                    if (user) {
                        event.preventDefault()
                        this.select(user)
                    }
                    return
                }

                if (event.key === 'Escape' && angular.isFunction(this.onCancel)) {
                    event.preventDefault()
                    this.onCancel()
                }
            }

            this.hasNoResults = () => !this.loading && !this.loadError && this.visibleUsers.length === 0
            this.hasMoreResults = () => this.results.length > this.visibleUsers.length

            const normalizedQuery = () => (this.query || '').trim()

            const moveActive = direction => {
                if (!this.visibleUsers.length) {
                    return
                }

                const nextIndex = this.activeIndex + direction
                if (nextIndex < 0) {
                    this.activeIndex = this.visibleUsers.length - 1
                    return
                }
                if (nextIndex >= this.visibleUsers.length) {
                    this.activeIndex = 0
                    return
                }

                this.activeIndex = nextIndex
            }

            const sortUsers = items => {
                if (!angular.isArray(items)) {
                    return []
                }

                return items.slice().sort((a, b) => (a.fullName || '').localeCompare(b.fullName || '', 'pl', {sensitivity: 'base'}))
            }
        }
    })
